<template>
  <UiTable
    v-if="databases"
    class="ui-stats-database-table"
    :data="databases"
    :columns="columnDefs"
    :is-striped="true"
  >
    <template #column-name="{ row }">
      <BaseLink :to="'/database/' + row.id" icon-size="size-7">{{
        ls(row.name)
      }}</BaseLink>
    </template>
    <template #column-org="{ row }">
      <BaseLink v-if="row.provider" :to="row.providerUrl" icon-size="size-7">
        <UiOrgProviderSpan class="link-text" :id="row.provider" />
      </BaseLink>
    </template>
    <template #column-tunagi="{ row }">
      <BaseLink :to="'/organization/' + row.permission.ownerOrg" icon-size="size-7">
        <UiOrgSpan :id="row.permission.ownerOrg" class="link-text" />
      </BaseLink>
    </template>
  </UiTable>
</template>

<script lang="ts" setup>
import type { ColumnDef } from '~/components/ui/UiTable.vue'
import { dapLangGlobal } from '#imports'

const { ls, lss, lc, num, led } = useI18n()
const { isHina } = useServiceType()
const { $getCodeDbCategory } = useNuxtApp()

interface Props {
  databases: Database[]
}
const props = withDefaults(defineProps<Props>(), {})

const dbCategoryCode: Code = $getCodeDbCategory()

const columnDefs: ColumnDef[] = [
  {
    label: () => lss('名称', 'Name'),
    path: ['name'],
    class: 'jps-srt-name',
    sort: 'name.yomi.sort',
    key: 'name',
  },
  {
    label: () => ls(dapLangGlobal.stats.database.category),
    path: ['category'],
    class: 'jps-srt-cat',
    display: c => lc(dbCategoryCode, c),
  },
  {
    label: () => lss('レコード数', 'Record'),
    path: ['recordCount'],
    class: 'jps-srt-count',
    sort: 'recordCount',
    display: (n) => num(n),
  },
  isHina ? null : {
    label: () => lss('所蔵・所在', 'Contents holder/Provider'),
    class: 'jps-srt-org',
    key: 'org',
  },
  isHina ? null : {
    label: () => lss('つなぎ役機関', 'Aggregator'),
    class: 'jps-srt-org',
    key: 'tunagi',
  },
  {
    label: () => lss('API'),
    path: ['apiType'],
    class: 'jps-srt-api',
    display: (c: APIType) => led(A_P_I_TYPE_DEF, c),
  },
].filter(v => v)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-stats-database-table {
  font-size: $size-8;
  max-width: 1000px;
  margin: 0 auto;

  .link-text {
    vertical-align: middle;
  }

  :deep(th) {
    white-space: nowrap;
  }
}
</style>
